import api, { adminApiPrefix } from './Api';
import {
  Tag,
  tagFromResponse,
  tagToUpsertRequest,
} from '../interfaces/Tag/Tag';

const tagAdminApiPrefix = `${adminApiPrefix}/tags`;

export const createTag = async (tag: Tag): Promise<Tag> => {
  const response = await api.post(tagAdminApiPrefix, tagToUpsertRequest(tag));

  return tagFromResponse(response.data?.data);
};

export const getTags = async (): Promise<Tag[]> => {
  const response = await api.get(tagAdminApiPrefix);

  return (response.data?.data ?? []).map((tag: any) => tagFromResponse(tag));
};

export const getTag = async (id: number): Promise<Tag> => {
  const response = await api.get(`${tagAdminApiPrefix}/${id}`);

  return tagFromResponse(response.data?.data);
};

export const updateTag = async (tag: Tag): Promise<Tag> => {
  const response = await api.put(
    `${tagAdminApiPrefix}/${tag.id}`,
    tagToUpsertRequest(tag),
  );

  return tagFromResponse(response.data?.data);
};

export const deleteTag = async (id: number): Promise<void> =>
  api.delete(`${tagAdminApiPrefix}/${id}`);
